import React, { FunctionComponent } from 'react';

import { Translate } from 'react-localize-redux';

import styled from 'styled-components';

import Flex from '@components/layout/flex';
import Typography from '@components/basics/typography';
import ButtonArrow from '@components/actions/arrow-button';
import FormContainer from '@components/layout/form-container';

import PasswordCtrl from '@webapp/controllers/registration/password';
import EmailOrPhoneCtrl from '@webapp/controllers/form/email-or-phone';

interface PasswordPromptPageProps {
  className?: string;
}

const PasswordPromptPage: FunctionComponent<PasswordPromptPageProps> = ({
  className,
}) => {
  const [email, setEmail] = React.useState('');
  const [password, setPassword] = React.useState('');
  // TODO: DEVTEAM-845 - Integrate with inputs validation
  const buttonDisabled = false;

  return (
    <FormContainer className={className || ''}>
      <Title type="subheader" customFont="semi-bold">
        <Translate id="2FA.PROMPT.PASSWORD.TITLE" />
      </Title>
      <Flex alignItems="center" justifyContent="space-between" gap={10}>
        <Wrapper>
          <EmailOrPhoneCtrl
            isGrey
            type="email"
            value={email}
            onChange={(contact) => setEmail(contact.value)}
          />
          <PasswordCtrl
            isGrey
            name="password"
            password={password}
            autoComplete="password"
            onChange={setPassword}
          />
        </Wrapper>
        <ButtonArrow className="button-arrow" disabled={buttonDisabled} />
      </Flex>
      <Separator />
      <Link className="mt-40" type="small">
        <Translate id="2FA.PROMPT.PASSWORD.HELP" />
      </Link>
    </FormContainer>
  );
};

export default styled(PasswordPromptPage)`
  .button-arrow {
    height: 108px;
    max-width: 78px;
    @media ${({ theme }) => theme.device.tablet} {
      height: 125px;
    }
  }
`;

const Title = styled(Typography)`
  margin-top: 24px;
  margin-bottom: 20px;
  @media ${({ theme }) => theme.device.tablet} {
    margin-top: 80px;
    margin-bottom: 30px;
  }
`;

const Wrapper = styled.div`
  display: grid;
  grid-gap: 5px;
  width: 100%;
`;

const Link = styled(Typography)`
  cursor: pointer;
  opacity: 1;
  text-align: center;
  transition: opacity
    ${({ theme }) => `${theme.transitions.duration} ${theme.transitions.type}`};

  &:hover {
    opacity: 0.75;
  }

  @media ${({ theme }) => theme.device.laptopL} {
    text-align: left;
  }
`;

const Separator = styled.span`
  width: 100%;
  height: 1px;
  margin-top: 1px;
  display: block;
  margin-top: 20px;
  background-color: ${({ theme }) => theme.colors.headerBorder};
  @media ${({ theme }) => theme.device.laptopL} {
    display: none;
  }
`;
